import React from 'react';
import { getTaxStatus } from '__utils/common-utils';
import './index.css';

interface CustomProps extends React.AllHTMLAttributes<HTMLInputElement> {
    radiobuttonRef?: any,
    userData: any
}

const LoginCustomerRadio: React.FC<CustomProps> = ({ value, radiobuttonRef, userData }) => {

    return (<div>
        <label className="loginLabel">
            <input
                className={"radio-input"}
                type="radio"
                name='loginUser'
                value={value}
                ref={radiobuttonRef}
            />
            <div className="radio-div">
                <p className='boldFt16 login-ellipsis'>{userData?.name}</p>
                <p>{getTaxStatus(userData?.taxStatus)}</p>
                <span className='checkmark'></span>
            </div>
        </label>
    </div>)

}
export default LoginCustomerRadio